var _rect, _circle, _g, _circle2, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.2 249.4",
    enableBackground: "new 0 0 167.2 249.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5.7,
    y: -5.7,
    fill: "#F8ABAA",
    width: 178.6,
    height: 260.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 20.8,
    cy: 39.2,
    r: 2.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 15.3198 29.7173)",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 20
  }, "2"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 146.4,
    cy: 210.3,
    r: 2.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-1 0 0 -1 151.9238 219.7319)",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 20
  }, "2"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0649B",
    points: "143.4,169.2 25.5,202 25.5,135 77.7,80.3 143.4,102.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDEFDB",
    points: "143.4,169.2 25.5,202 25.5,135 143.4,102.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5D0C0",
    points: "143.4,169.2 25.5,202 25.5,196.8 143.4,164  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5CCAD",
    d: "M134.5,154.9c-5.6,1.6-5.1,3.3-10.7,4.9c-5.6,1.6-6.1-0.2-11.7,1.3c-5.6,1.6-5.1,3.3-10.7,4.9 c-5.6,1.6-6.1-0.2-11.7,1.3c-5.6,1.6-5.1,3.3-10.7,4.9c-5.6,1.6-6.1-0.2-11.7,1.3c-5.6,1.6-5.1,3.3-10.7,4.9 c-5.6,1.6-6.1-0.2-11.7,1.3c-5.6,1.6-5.1,3.3-10.7,4.9c-4.5,1.3-5.7,0.4-8.9,0.8V202l117.9-32.8v-15.1 C140.2,154.6,139,153.6,134.5,154.9z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#E5CCAD",
    d: "M137.5,127.7c-6.8,1.9-4.7,9.1-11.5,11c-6.8,1.9-8.8-5.3-15.5-3.5c-6.8,1.9-4.7,9.1-11.5,11 c-6.8,1.9-8.8-5.3-15.5-3.5c-6.8,1.9-4.7,9.1-11.5,11c-6.8,1.9-8.8-5.3-15.5-3.5c-6.8,1.9-4.7,9.1-11.5,11 c-6.8,1.9-8.8-5.3-15.5-3.4c-1.8,0.5-3,1.5-3.9,2.6v14.1c3.2-0.4,4.4,0.5,8.9-0.7c5.6-1.6,5.1-3.3,10.7-4.9 c5.6-1.6,6.1,0.2,11.7-1.3c5.6-1.6,5.1-3.3,10.7-4.9c5.6-1.6,6.1,0.2,11.7-1.3c5.6-1.6,5.1-3.3,10.7-4.9c5.6-1.6,6.1,0.2,11.7-1.3 c5.6-1.6,5.1-3.3,10.7-4.9c5.6-1.6,6.1,0.2,11.7-1.3c5.6-1.6,5.1-3.3,10.7-4.9c4.5-1.3,5.7-0.4,8.9-0.8v-14.7 C141.7,127.6,139.9,127,137.5,127.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.5,193v-5.3l46.4-53.5c8.8-10.2,15.2-19,19.3-26.4c4.1-7.4,6.1-14.2,6.1-20.5c0-10.3-2.9-18.3-8.6-24.1 c-5.7-5.8-14-8.7-25-8.7c-11.6,0-20.6,3.4-26.9,10.2c-6.4,6.8-9.5,15.6-9.5,26.4h-4.5l-0.2-0.6c-0.3-11.5,3.3-21.2,10.8-29.3 c7.6-8,17.6-12.1,30.3-12.1c11.7,0,21.1,3.3,28.2,10c7.1,6.6,10.6,16,10.6,28.1c0,7.8-2.5,15.8-7.6,24 c-5.1,8.2-12.3,17.7-21.5,28.5l-40.5,47.4l0.2,0.5H120v-23.2h5.3V193H40.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7F6CB1",
    d: "M84.6,109.3L84.6,109.3c-0.6,0.1-1.2-0.3-1.3-1l-0.4-2.9c-0.1-0.6,0.3-1.2,1-1.3h0c0.6-0.1,1.2,0.3,1.3,1 l0.4,2.9C85.7,108.6,85.3,109.2,84.6,109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0A88F",
    d: "M72.2,93.7L72.2,93.7c0-0.6,0.5-1.2,1.1-1.2l3-0.1c0.6,0,1.2,0.5,1.2,1.1l0,0c0,0.6-0.5,1.2-1.1,1.2l-3,0.1 C72.8,94.8,72.3,94.3,72.2,93.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0A88F",
    d: "M118.3,100.3L118.3,100.3c-0.3-0.6,0-1.3,0.6-1.5l2.7-1.2c0.6-0.3,1.3,0,1.5,0.6l0,0c0.3,0.6,0,1.3-0.6,1.5 l-2.7,1.2C119.3,101.1,118.6,100.9,118.3,100.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5DFF2",
    d: "M71.3,116.9L71.3,116.9c0-0.6,0.6-1.2,1.2-1.1l3,0.1c0.6,0,1.2,0.6,1.1,1.2l0,0c0,0.6-0.6,1.2-1.2,1.1 l-3-0.1C71.8,118.1,71.3,117.6,71.3,116.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBB5BB",
    d: "M41.4,125.1L41.4,125.1c-0.2-0.6,0.2-1.3,0.9-1.4l2.9-0.7c0.6-0.2,1.3,0.2,1.4,0.9l0,0 c0.2,0.6-0.2,1.3-0.9,1.4l-2.9,0.7C42.2,126.1,41.6,125.7,41.4,125.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F6CB1",
    d: "M57.8,122.4L57.8,122.4c-0.4-0.5-0.3-1.2,0.2-1.6l2.3-1.8c0.5-0.4,1.2-0.3,1.6,0.2l0,0 c0.4,0.5,0.3,1.2-0.2,1.6l-2.3,1.8C59,123,58.2,122.9,57.8,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3B7F",
    d: "M51.3,114L51.3,114c-0.4-0.5-0.3-1.2,0.2-1.6l2.3-1.8c0.5-0.4,1.2-0.3,1.6,0.2v0c0.4,0.5,0.3,1.2-0.2,1.6 l-2.3,1.8C52.4,114.5,51.7,114.5,51.3,114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBB5BB",
    d: "M67.9,104L67.9,104c-0.3,0.6-0.9,0.9-1.5,0.6l-2.7-1.2c-0.6-0.3-0.9-0.9-0.6-1.5v0c0.3-0.6,0.9-0.9,1.5-0.6 l2.7,1.2C67.9,102.7,68.2,103.4,67.9,104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F0D4",
    d: "M85,96.1L85,96.1c-0.6,0.2-1.3-0.2-1.4-0.8l-0.8-2.8c-0.2-0.6,0.2-1.3,0.8-1.4l0,0c0.6-0.2,1.3,0.2,1.4,0.8 l0.8,2.8C85.9,95.3,85.6,96,85,96.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F6CB1",
    d: "M100.4,103.5L100.4,103.5c-0.1-0.6,0.3-1.3,0.9-1.4l2.9-0.6c0.6-0.1,1.3,0.3,1.4,0.9l0,0 c0.1,0.6-0.3,1.3-0.9,1.4l-2.9,0.6C101.1,104.5,100.5,104.1,100.4,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91C6E6",
    d: "M91,93.5L91,93.5c0-0.6,0.6-1.2,1.2-1.1l3,0.1c0.6,0,1.2,0.6,1.1,1.2v0c0,0.6-0.6,1.2-1.2,1.1l-3-0.1 C91.4,94.7,90.9,94.1,91,93.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1394A",
    d: "M110.7,103.2c7.6-7.5,7.6-19.8,0-27.4c-7.5-7.6-19.8-7.6-27.4,0c-9.3,9.3-10.3,29-6,33.3 C81.6,113.3,102.1,111.7,110.7,103.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7061 0.7082 -0.7082 0.7061 90.5783 -44.9617)",
    fill: "#DEDAC6",
    cx: 99.4,
    cy: 86.6,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3735 0.9276 -0.9276 0.3735 157.8687 -27.6783)",
    fill: "#DEDAC6",
    cx: 99.4,
    cy: 103,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8285 0.56 -0.56 0.8285 71.5817 -44.0142)",
    fill: "#DEDAC6",
    cx: 107.6,
    cy: 94.8,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8491 0.5283 -0.5283 0.8491 59.155 -30.5511)",
    fill: "#DEDAC6",
    cx: 83,
    cy: 88.2,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8491 0.5283 -0.5283 0.8491 55.9983 -30.9891)",
    fill: "#DEDAC6",
    cx: 82.2,
    cy: 82.5,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.317 -0.9484 0.9484 -0.317 23.6894 218.1797)",
    fill: "#DEDAC6",
    cx: 90.4,
    cy: 100.6,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.5698 -0.8218 0.8218 -0.5698 78.1672 230.5823)",
    fill: "#DEDAC6",
    cx: 99.4,
    cy: 94.8,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.5698 -0.8218 0.8218 -0.5698 59.0207 245.1505)",
    fill: "#DEDAC6",
    cx: 93.7,
    cy: 107.1,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7061 -0.7082 0.7082 -0.7061 91.6526 222.7624)",
    fill: "#DEDAC6",
    cx: 92.1,
    cy: 92.4,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8609 -0.5088 0.5088 -0.8609 97.0788 234.1971)",
    fill: "#DEDAC6",
    cx: 80.6,
    cy: 103.8,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2255 -0.9742 0.9742 -0.2255 0.3917 214.541)",
    fill: "#DEDAC6",
    cx: 85.5,
    cy: 107.1,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9099 -0.4149 0.4149 -0.9099 168.4345 208.2264)",
    fill: "#DEDAC6",
    cx: 106.8,
    cy: 85.8,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.44 -0.898 0.898 -0.44 68.5157 201.2137)",
    fill: "#DEDAC6",
    cx: 97,
    cy: 79.2,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.44 -0.898 0.898 -0.44 68.6673 193.0982)",
    fill: "#DEDAC6",
    cx: 94.5,
    cy: 75.1,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8563 -0.5164 0.5164 -0.8563 121.5994 188.8094)",
    fill: "#DEDAC6",
    cx: 87.1,
    cy: 77.5,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.6209 -0.7839 0.7839 -0.6209 80.6094 207.2931)",
    fill: "#DEDAC6",
    cx: 90.4,
    cy: 84.2,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.842 -0.5395 0.5395 -0.842 103.7479 218.3638)",
    fill: "#DEDAC6",
    cx: 83.9,
    cy: 94,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9619 -0.2735 0.2735 -0.9619 126.8586 210.5671)",
    fill: "#DEDAC6",
    cx: 78.1,
    cy: 96.4,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7061 -0.7082 0.7082 -0.7061 110.9975 247.2412)",
    fill: "#DEDAC6",
    cx: 106.8,
    cy: 100.6,
    rx: 0.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94A979",
    d: "M117.7,76.7c-1.2-0.1-2.4-0.1-3.5,0c1.1-0.7,2.2-1.5,3.2-2.5c3-2.9,4.8-6.7,5.3-10.5 c-3.9,0.4-7.7,2.1-10.7,5c-0.8,0.8-1.6,1.7-2.2,2.6c0.1-1,0.2-1.9,0.1-2.9c-0.2-4.2-1.8-8-4.3-11c-2.3,3.2-3.6,7.1-3.4,11.3 c0.2,4,1.7,7.7,4,10.6c0,0,0.3,0.4,0.3,0.3c2.8,2.5,6.3,4.2,10.3,4.7c4.2,0.4,8.2-0.6,11.5-2.7C125.6,79,121.9,77.1,117.7,76.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 75.9,
    cy: 108.5,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 84.9,
    cy: 110.4,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 94.4,
    cy: 110.4,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 103,
    cy: 108.5,
    r: 5.4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0649B",
    d: "M31.4,146.6c6.8-1.9,4.7-9.1,11.5-11c6.8-1.9,8.8,5.3,15.5,3.5c6.8-1.9,4.7-9.1,11.5-11 c6.8-1.9,8.8,5.3,15.5,3.5c6.8-1.9,4.7-9.1,11.5-11c6.8-1.9,8.8,5.3,15.5,3.5c6.8-1.9,4.7-9.1,11.5-11c6.8-1.9,8.8,5.3,15.5,3.4 c1.8-0.5,3-1.5,3.9-2.6v-11.7L25.5,135v10.8C27.2,146.7,29,147.2,31.4,146.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 30.7,
    cy: 135.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 33.2,
    cy: 133.7,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 36,
    cy: 133.6,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 39.1,
    cy: 132.2,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 42.7,
    cy: 131,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 46.3,
    cy: 130.5,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 50.5,
    cy: 128.5,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 54.7,
    cy: 125.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 59.6,
    cy: 126.3,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 64.1,
    cy: 123.8,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 68.3,
    cy: 123.3,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 71.7,
    cy: 122.4,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 75.5,
    cy: 121,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 79.1,
    cy: 120.4,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 82.4,
    cy: 119.3,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 86.4,
    cy: 119.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 93,
    cy: 117.2,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 96.7,
    cy: 115.8,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 100.8,
    cy: 114.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 104.7,
    cy: 113.3,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 108.6,
    cy: 112.4,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 111.4,
    cy: 110.5,
    r: 3.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 116.4,
    cy: 110.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F0649B",
    cx: 120.1,
    cy: 108.8,
    rx: 2,
    ry: 2.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F0649B",
    cx: 122.9,
    cy: 108.3,
    rx: 2.1,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F0649B",
    cx: 126,
    cy: 107.4,
    rx: 2.1,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F0649B",
    cx: 129.3,
    cy: 106.5,
    rx: 2.1,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F0649B",
    cx: 132.4,
    cy: 106,
    rx: 2.1,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F0649B",
    cx: 136.2,
    cy: 104.8,
    rx: 2.1,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F0649B",
    cx: 139.9,
    cy: 104.9,
    rx: 2.7,
    ry: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0649B",
    cx: 89.4,
    cy: 117.6,
    r: 1.7
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7F6CB1",
    d: "M70.5,111.1L70.5,111.1c-0.6-0.2-1-0.8-0.8-1.4l0.7-2.9c0.2-0.6,0.8-1,1.4-0.8h0c0.6,0.2,1,0.8,0.8,1.4 l-0.7,2.9C71.7,110.9,71.1,111.3,70.5,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F6CB1",
    d: "M98.1,113L98.1,113c-0.4-0.5-0.3-1.2,0.2-1.6l2.3-1.8c0.5-0.4,1.2-0.3,1.6,0.2l0,0c0.4,0.5,0.3,1.2-0.2,1.6 l-2.3,1.8C99.2,113.6,98.5,113.5,98.1,113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5DFF2",
    d: "M81.9,109.2L81.9,109.2c0.3-0.6,1-0.8,1.6-0.5l2.6,1.4c0.6,0.3,0.8,1,0.5,1.6l0,0c-0.3,0.6-1,0.8-1.6,0.5 l-2.6-1.4C81.8,110.5,81.6,109.8,81.9,109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5CCAD",
    d: "M34.4,183.1c5.6-1.6,5.1-3.3,10.7-4.9c5.6-1.6,6.1,0.2,11.7-1.3c5.6-1.6,5.1-3.3,10.7-4.9 c5.6-1.6,6.1,0.2,11.7-1.3c5.6-1.6,5.1-3.3,10.7-4.9c5.6-1.6,6.1,0.2,11.7-1.3c5.6-1.6,5.1-3.3,10.7-4.9c5.6-1.6,6.1,0.2,11.7-1.3 c5.6-1.6,5.1-3.3,10.7-4.9c4.5-1.3,5.7-0.4,8.9-0.8v-7.8c-3.2,0.4-4.4-0.5-8.9,0.7c-5.6,1.6-5.1,3.3-10.7,4.9 c-5.6,1.6-6.1-0.2-11.7,1.3c-5.6,1.6-5.1,3.3-10.7,4.9c-5.6,1.6-6.1-0.2-11.7,1.3c-5.6,1.6-5.1,3.3-10.7,4.9 c-5.6,1.6-6.1-0.2-11.7,1.3c-5.6,1.6-5.1,3.3-10.7,4.9c-5.6,1.6-6.1-0.2-11.7,1.3c-5.6,1.6-5.1,3.3-10.7,4.9 c-4.5,1.3-5.7,0.4-8.9,0.8v7.8C28.7,183.4,29.9,184.4,34.4,183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5CCAD",
    d: "M123.8,161.6c-5.6,1.6-6.1-0.2-11.7,1.3c-5.6,1.6,1.2,14.6,1.2,14.6l12.2-3.4 C125.5,174.2,129.4,160.1,123.8,161.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E5CCAD",
    cx: 41.5,
    cy: 191,
    rx: 3.7,
    ry: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5DFF2",
    d: "M128.5,103.1L128.5,103.1c0.2-0.6,0.8-1,1.5-0.8l2.8,0.8c0.6,0.2,1,0.8,0.8,1.5l0,0c-0.2,0.6-0.8,1-1.5,0.8 l-2.8-0.8C128.7,104.4,128.3,103.8,128.5,103.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 36,
    cy: 180,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 45.4,
    cy: 173.4,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 76.3,
    cy: 168.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 82.9,
    cy: 163.1,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 101.6,
    cy: 162.2,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 92.2,
    cy: 163.1,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 120.3,
    cy: 153.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 112.8,
    cy: 154.7,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 107.2,
    cy: 158.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 97.8,
    cy: 160.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 80,
    cy: 166.7,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 69.8,
    cy: 169.6,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 60.4,
    cy: 169.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 55.8,
    cy: 174.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 116.6,
    cy: 156.6,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 139,
    cy: 148.2,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 128.7,
    cy: 151.9,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 70.7,
    cy: 166,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 51.9,
    cy: 172.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573B2E",
    cx: 32.3,
    cy: 178.1,
    r: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.1f4f56b57e14b88994d725bb1115e040.svg";
export { ForwardRef as ReactComponent };